import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-iap-reconnect-dialog',
  templateUrl: './iap-reconnect-dialog.component.html',
  styleUrls: ['./iap-reconnect-dialog.component.scss']
})
export class IapReconnectDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IapReconnectDialogComponent>) {
  }

  ngOnInit() {
  }

  reconnect(): void {
    window.open('/_gcp_iap/do_session_refresh');
    this.dialogRef.close();
  }
}
